import __request__ from "routing/request";
export function getPage(filterId, page = 1, per_page = 50, query, type = "SEARCH", sort = "title", order = "asc", requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.searchfilters/search_filters_usage/details/${filterId}/paginated`, null, { "page": page, "per_page": per_page, "query": query, "type": type, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(filterId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.searchfilters/search_filters_usage/summary/${filterId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
